var path = 'app/core/views/empty.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;